import { AnalysisFlow } from '@/components/AnalysisFlow';

export function NewAnalysis() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-text-primary">New analysis</h1>
        <p className="mt-1 text-sm text-text-secondary">
          Enter a website URL. We’ll inspect it, infer the brand for you to confirm, and run the
          analysis — saving the results to a new project.
        </p>
      </div>
      <AnalysisFlow mode="registered" />
    </div>
  );
}
